import React, { Fragment, useEffect } from "react";
import { clearProductDetail, fetchDeleteProduct } from "../actions/product";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchProductList } from "../actions/product";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ProductList = () => {
  const dispatch = useDispatch();

  const { productList } = useSelector((state) => state.productReducer);
  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "products";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchProductList());
    dispatch(clearProductDetail());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/product-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteProduct(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("promotionList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("productList.productName"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: t("productList.serialNumber"),
      field: "serialNumber",
      filter: "agTextColumnFilter",
      width: 200,
    },
    {
      headerName: t("productList.ean"),
      field: "ean",
      filter: "agTextColumnFilter",
      width: 200,
    },
    {
      headerName: t("productList.points"),
      field: "points",
      filter: "agTextColumnFilter",
      width: 160,
    },
    {
      headerName: t("productList.category"),
      field: "categoryName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: t("productList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("productList.inactive");
          case "ACTIVE":
            return t("productList.active");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("productList.creationDate"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },

    {
      headerName: t("productList.lastUpdatedDate"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={productList}
        columnDefs={columnDefs}
        buttonLink={`/product-add`}
        importButton={true}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"product-list"}
      />
    </Fragment>
  );
};

export default ProductList;
